import { render, staticRenderFns } from "./Approvemy.vue?vue&type=template&id=3c585daa&"
import script from "./Approvemy.vue?vue&type=script&lang=js&"
export * from "./Approvemy.vue?vue&type=script&lang=js&"
import style0 from "./Approvemy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports